import React, {Component} from 'react';
import withNofeshService  from '../../hoc/withNofeshService.hoc';
import {

    Redirect 
  } from "react-router-dom";

  import { Weekdays_placeholder } from '../../utils/constUtils';
import Places from '../../data/places.data'
import compose from '../../utils/compose'
import Spinner from 'react-bootstrap/Spinner'


class SearchPanelResults extends Component {

    unsubscribe = null;
    state = {
        redirect : null,
        searchFieldWeekdays_placeholder:'',
        searchFieldPlaces_placeholder:'',
        searchFieldDates_placeholder:'',
        searchFieldGuests_placeholder:''
    }

    newSearch = () => {        
        this.setState({ redirect: "/" });        
    }
    

    places_placeholder = (places) =>  { 
        let s = '';
        let addComa = false;
               

        if (places.checkedEilat) {
            s = Places.Eilat();
            addComa = true;
        }
        if (places.checkedDeadSea) {
            if (addComa) s = s + ',';
            s = s + Places.DeadSea();
            addComa = true;
        }
        if (places.checkedLowerGalilee) {
            if (addComa) s = s + ',';
            s = s + Places.LowerGalilee();
            addComa = true;
        }
        if (places.checkedUpperGalilee) {
            if (addComa) s = s + ',';
            s = s + Places.UpperGalilee();
            addComa = true;
        }

        if (places.checkedWestGalilee) {
            if (addComa) s = s + ',';
            s = s + Places.WestGalilee();
            addComa = true;
        }


        if (places.checkedKineret) {
            if (addComa) s = s + ',';
            s = s + Places.Kineret();
            addComa = true;
        }

        if (places.checkedMerchaz) {
            if (addComa) s = s + ',';
            s = s + Places.Merchaz();
            addComa = true;
        }

        if (places.checkedJerusalem) {
            if (addComa) s = s + ',';
            s = s + Places.Jerusalem();
            addComa = true;
        }

        if (places.checkedHasharon) {
            if (addComa) s = s + ',';
            s = s + Places.Hasharon();
            addComa = true;
        }

        //if ( s.length > 28) {s = s.substring(0,27) + ' ...';}
        return s;
        

    }
    


    componentDidMount = () => { 
        const {currentSearchObj} = this.props;
        //currentSearchObj.search_param_dates_months     
        //currentSearchObj.search_param_dates_range 
        const searchFieldWeekdays_placeholder = Weekdays_placeholder(currentSearchObj.search_param_weekdays);
        this.setState({ searchFieldWeekdays_placeholder: searchFieldWeekdays_placeholder});
        if ( currentSearchObj.search_param_places) {

            console.log('SearchPanelResults componentDidMount currentSearchObj: ',  currentSearchObj.search_param_places);
        
            const searchFieldPlaces_placeholder = this.places_placeholder(currentSearchObj.search_param_places);
            this.setState({ searchFieldPlaces_placeholder: searchFieldPlaces_placeholder});
        }

        if ( currentSearchObj.searchFieldDates_placeholder) {
            this.setState({ searchFieldDates_placeholder:  currentSearchObj.searchFieldDates_placeholder});
        }
       
        if ( currentSearchObj.searchFieldGuests_placeholder) {
            this.setState({ searchFieldGuests_placeholder:  currentSearchObj.searchFieldGuests_placeholder});
        }

    }
   

    render() { 

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }           
        return (            
                <div className="cntered-flex" >                    
                    <div className="hp_search_box">
                        <div className="hp_search_title">
                            <div className="hp_search_title_inner_div">
                                <div className="paddingTop15">החיפוש שלך</div>
                            </div>
                        </div>		
                        <div className="hp_search_pad1_line"></div>

                        <div className="hp_search_results_middlePad">
                            <div className="hp_search_title2">
                                <div className="cntered-flex">
                                    <div className="hp_search_resultsContainer1">
                                        <div className="hp_search_results_font justifyContentRight">
                                            <div className="hp_search_results_cell">
                                                <div className="blockTextRight">
                                                    <div className="blockTextRight">
                                                        {this.state.searchFieldGuests_placeholder}
                                                    </div>
                                                    <div className="blblockTextRightock">
                                                        {this.state.searchFieldPlaces_placeholder}
                                                    
                                                    </div>
                                                </div>
                                                <div>
                                                    <img src={"./images/site/complete-2.png"} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div></div>
                                        <div className="hp_search_resultsLine"></div>
                                        <div></div>
                                        <div className="hp_search_results_font">
                                            <div className="hp_search_results_cell">
                                                <div className="blockTextRight">
                                                    <div className="blockTextRight">
                                                       {this.state.searchFieldWeekdays_placeholder}
                                                        
                                                    </div>
                                                    <div className="blockTextRight">
                                                        {this.state.searchFieldDates_placeholder}
                                                    </div>  
                                                </div>    
                                                <div>
                                                    <img src={"./images/site/complete-2.png"} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                                            
                        <div className="hp_search_results_bottomPad">
                            <div className="hp_search_results_middlePad2"></div>
                            <div className="cntered-flex">
                                <div className="hp_search_results_btnNew" 
                                    onClick={() => this.newSearch()}>
                                       <img className="margingBottom" src={"/images/site/search.png"} />
                                    <span className="hp_search_results_btnNewText">חיפוש חדש</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>		
            
        )
    }
}


export default compose(
    withNofeshService()
  )(SearchPanelResults);
  
